export default "__VITE_ASSET__021303ac__"